export const SERVER = location.hostname === "localhost" ? "https://localhost:3001" : "https://api.gridprof.com";

// Every call carries the session cookie. Without credentials: 'include' the
// cross-origin cookie is never sent and every request 401s.
export async function api(path, init = {}) {
   return fetch(`${SERVER}${path}`, {
      ...init,
      credentials: "include",
      headers: {
         "Content-Type": "application/json",
         ...(init.headers || {}),
      },
   });
}

export function setMsg(id, text, kind = "") {
   const el = document.getElementById(id);
   if (!el) return;
   el.textContent = text;
   el.className = `msg${kind ? " " + kind : ""}`;
}
